import countdown from "../countdown"
import exitIntentPopup from "../exitIntentPopup"
import primer from "../primer"

export default (getView) => (nextStepPath, timeoutSeconds, popupStepPath) => ({
  ...getView(nextStepPath),
  ...countdown(timeoutSeconds),
  ...primer(),
  ...exitIntentPopup(popupStepPath),

  statusToTrack: "VISIT_CHECKOUT",

  async onInit() {
    this.initCountdown()
    this.store.restorePurchasedBasicOffer()

    if (
      this.store.values.exitIntent &&
      new URLSearchParams(window.location.hash.substr(1)).has("token")
    ) {
      this.store.values.exitIntent = false
      await this.store.push()
    }

    this.initPrimer({
      checkoutCompletePath: nextStepPath,
    })

    if (popupStepPath) this.initExitIntentPopup()
  },
})
